import { ref } from 'vue'

/**
 * The last QR signature notice, shown app-wide by QrVerificationToast.vue.
 *
 * Lives outside the scanner components because several flows close the
 * scanner the moment a scan succeeds (LoadCoach, LoadTransferV2...), which would
 * take a notice rendered inside it away before anyone saw it.
 */
const notice = ref(null)
let timer = null
let seq = 0

const DURATION_MS = { verified: 2500, warning: 6000, blocked: 6000 }

/** @param {{type: 'verified'|'warning'|'blocked', text: string}|null} next */
export function showQrNotice(next) {
  if (timer) clearTimeout(timer)
  timer = null
  if (!next) {
    notice.value = null
    return
  }
  notice.value = { ...next, id: ++seq }
  timer = setTimeout(() => { notice.value = null; timer = null }, DURATION_MS[next.type] ?? 4000)
}

export function dismissQrNotice() {
  showQrNotice(null)
}

export function useQrNotice() {
  return { notice, showQrNotice, dismissQrNotice }
}
